let allDefs = {
    b2c: [{
        title: 'Meno',
        name: 'fName',
        help: 'Meno osoby uvedenej na Zmluve o pripojení',
        value: '',
        isErr: false,
        errText: 'Meno nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'Priezvisko',
        name: 'surName',
        help: 'Priezvisko osoby uvedenej na Zmluve o pripojení',
        value: '',
        isErr: false,
        errText: 'Priezvisko nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'Rodné číslo',
        name: 'personalId',
        help: 'Rodné číslo osoby uvedenej na Zmluve o pripojení, bez lomítka a bez medzier',
        value: '',
        isErr: false,
        errText: 'Rodné číslo nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'Číslo adresáta z faktúry',
        name: 'bpn',
        help: 'Číslo adresáta nájdete v pravom hornom rohu svojej faktúry za služby Telekom a tiež v mobilnej aplikácii Telekom na obrazovke Detail faktúry (prístupná cez menu Platby).',
        value: '',
        isErr: false,
        errText: 'Adresát nie je správne vyplnený.',
        isReadOnly: false
    }],
    b2b: [{
        title: 'IČO',
        name: 'regNo',
        help: '',
        value: '',
        isErr: false,
        errText: 'IČO nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'Meno primárnej kontaktnej osoby',
        name: 'primaryFName',
        help: '',
        value: '',
        isErr: false,
        errText: 'Meno nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'Priezvisko primárnej kontaktnej osoby',
        name: 'primarySurName',
        help: '',
        value: '',
        isErr: false,
        errText: 'Priezvisko nie je správne vyplnené.',
        isReadOnly: false
    },
    {
        title: 'PID kód',
        name: 'pid',
        help: '',
        value: '',
        isErr: false,
        errText: 'PID nie je správne vyplnený.',
        isReadOnly: false
    }]
}


var formDef = {
    resid: [{
        title: 'Meno',
        name: 'fName',
        help: 'Meno osoby uvedenej na Zmluve o pripojení',
        value: '',
        isErr: false,
        isReadOnly: false
    },
    {
        title: 'Priezvisko',
        name: 'surName',
        help: 'Priezvisko osoby uvedenej na Zmluve o pripojení',
        value: '',
        isErr: false,
        isReadOnly: false
    },
    {
        title: 'Rodné číslo',
        name: 'personalId',
        help: 'Rodné číslo osoby uvedenej na Zmluve o pripojení, bez lomítka a bez medzier',
        value: '',
        isErr: false,
        isReadOnly: false
    },
    {
        title: 'Číslo adresáta z faktúry',
        name: 'bpn',
        help: 'Číslo adresáta nájdete v pravom hornom rohu svojej faktúry za služby Telekom a tiež v mobilnej aplikácii Telekom na obrazovke Detail faktúry (prístupná cez menu Platby).',
        value: '',
        isErr: false,
        isReadOnly: false
    }
]}

module.exports = allDefs;